import * as React from "react";
import { Modal, Button } from "antd";

export interface State {}

export interface Props {
  translate: any;
  visible?: boolean;
  onOk?: any;
  onCancel: any;
}

export default class InvalidateQualifierModal extends React.Component<
  Props,
  State
> {
  render() {
    const { translate, visible, onOk, onCancel } = this.props;

    return (
      <div onClick={e => e.stopPropagation()}>
        <Modal
          title={translate("remove_qualifier_modal.title")}
          visible={visible}
          onCancel={onCancel}
          maskClosable={false}
          onOk={onOk}
          footer={[
            <Button key="back" onClick={onCancel}>
              {translate("modal_functions.remove_modal.cancel")}
            </Button>,
            <Button key="submit" type="danger" onClick={onOk}>
              {translate("modal_functions.remove_modal.remove")}
            </Button>
          ]}
        >
          {translate("remove_qualifier_modal.text")}
        </Modal>
      </div>
    );
  }
}
